<ng-container *ngIf="infos">
    <p>name:{{ infos?.name }} </p>
</ng-container>